import { useRef, useState } from 'react';

import { AlertDialog, Icon, Text } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import QRCode from 'components/qrcode';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';
import { isMobile } from 'utils/environment';

const DOWNLOAD_APP_LINK = 'https://burgerking.app.link/t5PCWDQqkXb';

export const InstallAppButton = () => {
  const [isDownloadDialogOpen, setIsDownloadDialogOpen] = useState(false);
  const { navigate } = useRouter();

  const handleAppInstallPress = () => {
    if (isMobile()) {
      navigate(DOWNLOAD_APP_LINK);
    } else {
      setIsDownloadDialogOpen(true);
    }
  };

  return (
    <>
      <ActionButton size={ActionButtonSizes.SMALL} onPress={handleAppInstallPress}>
        {t('installApp', 'Install App')}
      </ActionButton>
      <AlertDialog
        leastDestructiveRef={useRef(null)}
        isOpen={isDownloadDialogOpen}
        onClose={() => setIsDownloadDialogOpen(false)}
      >
        <AlertDialog.Content
          maxWidth={520}
          width="90%"
          style={{ padding: spacing.$2, gap: spacing.$3 }}
        >
          <AlertDialog.CloseButton />
          <AlertDialog.Header>
            <Text
              fontFamily="heading"
              style={{
                paddingVertical: spacing.$4,
                textAlign: 'center',
                color: primitive.$black,
                fontSize: primitive.fontSizes['2xl'],
              }}
            >
              {t('getBkApp', 'Get the Burger King App')}
            </Text>
          </AlertDialog.Header>
          <AlertDialog.Body
            style={{
              gap: spacing.$4,
              paddingTop: spacing.$4,
              paddingBottom: spacing.$7,
              alignItems: 'center',
            }}
          >
            <Text style={{ fontSize: primitive.fontSizes.xs }}>
              {t('scanWithPhoneForRewards', 'Scan with your phone and start earning rewards')}
            </Text>
            <QRCode
              barcode={DOWNLOAD_APP_LINK}
              options={{
                color: {
                  light: primitive.$white,
                  dark: primitive.$black,
                },
              }}
              borderWidth="8"
              borderStyle="solid"
              borderColor={primitive.$black}
              padding={4}
              borderRadius={8}
            />
            <ActionButton
              leftIcon={<Icon name="mi:smartphone" />}
              variant={ActionButtonVariants.OUTLINE}
            >
              {t('scanMeNow', 'Scan me now!')}
            </ActionButton>
          </AlertDialog.Body>
        </AlertDialog.Content>
      </AlertDialog>
    </>
  );
};
